(function () {
  if (window.__alkyraSampleBound) return;
  window.__alkyraSampleBound = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function isCartPage() {
    return !!document.querySelector('[data-cart-summary]');
  }

  function syncButtons(chosenVariantId) {
    document.querySelectorAll('.sample-pick__btn[data-sample-choose]').forEach(function (btn) {
      var chosen = String(btn.getAttribute('data-variant-id')) === String(chosenVariantId);
      btn.classList.toggle('is-chosen', chosen);
      btn.setAttribute('aria-pressed', chosen ? 'true' : 'false');
      var def = btn.querySelector('[data-sample-label-default]');
      var cho = btn.querySelector('[data-sample-label-chosen]');
      if (def) def.hidden = chosen;
      if (cho) cho.hidden = !chosen;
    });
  }

  function afterChange(cart, openDrawer, chosenVariantId) {
    if (isCartPage()) {
      window.location.reload();
      return;
    }
    syncButtons(chosenVariantId);
    document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart, source: 'sample' } }));
    // With 1 perfume a pick only changes a cart attribute, so the line keys stay the same: re-render explicitly.
    var drawer = document.querySelector('cart-drawer-section');
    if (drawer && typeof drawer.refresh === 'function') drawer.refresh();
    if (openDrawer) document.dispatchEvent(new CustomEvent('cart-drawer:open'));
  }

  // Adds a pick, dropping the oldest one when the customer already has all the picks they are allowed.
  // The "Elegida por nosotros" line is left alone: reconcile() decides how many stay.
  function choosePick(variantId) {
    return getCart().then(function (cart) {
      var picks = pickLines(cart);
      var already = picks.some(function (item) { return String(item.variant_id) === String(variantId); });
      if (already) return cart;
      var updates = {};
      // cart.items lists the newest line first, so the oldest picks are at the end.
      picks.slice(Math.max(maxPicks(cart), 1) - 1).forEach(function (item) { updates[item.variant_id] = 0; });
      updates[variantId] = 1;
      return post('cart/update.js', { updates: updates });
    });
  }

  function removePick(variantId) {
    var updates = {};
    updates[variantId] = 0;
    return post('cart/update.js', { updates: updates });
  }

  function loadAll(button) {
    var block = button.closest('[data-cart-sample]');
    var panel = block.querySelector('[data-sample-all-panel]');
    var list = block.querySelector('[data-sample-list]');
    var open = panel.hidden;
    panel.hidden = !open;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open || list.getAttribute('data-loaded')) return;
    list.setAttribute('data-loaded', '1');
    fetch(root + '?section_id=sample-list', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sample-list-items]');
        if (fresh) list.replaceChildren.apply(list, Array.from(fresh.children, function (n) { return document.importNode(n, true); }));
        var search = block.querySelector('[data-sample-search]');
        if (search) search.focus();
      })
      .catch(function () { list.removeAttribute('data-loaded'); });
  }

  document.addEventListener('click', function (event) {
    var choose = event.target.closest('[data-sample-choose]');
    if (choose) {
      event.preventDefault();
      if (choose.classList.contains('is-loading')) return;
      var variantId = choose.getAttribute('data-variant-id');
      var openDrawer = choose.hasAttribute('data-sample-open-drawer');
      choose.classList.add('is-loading');
      choosePick(variantId)
        .then(function (cart) { return reconcile(cart).then(function (fresh) { return fresh || cart; }); })
        .then(function (cart) { afterChange(cart, openDrawer, variantId); })
        .catch(function (err) { console.error('[sample] choose failed:', err && err.message); })
        .finally(function () { choose.classList.remove('is-loading'); });
      return;
    }

    var remove = event.target.closest('[data-sample-remove]');
    if (remove) {
      event.preventDefault();
      removePick(remove.getAttribute('data-variant-id'))
        .then(function (cart) { return reconcile(cart).then(function (fresh) { return fresh || cart; }); })
        .then(function (cart) { afterChange(cart, false, null); })
        .catch(function (err) { console.error('[sample] remove failed:', err && err.message); });
      return;
    }

    var all = event.target.closest('[data-sample-all]');
    if (all) {
      event.preventDefault();
      loadAll(all);
    }
  });

  document.addEventListener('input', function (event) {
    var search = event.target.closest('[data-sample-search]');
    if (!search) return;
    var q = search.value.trim().toLowerCase();
    var block = search.closest('[data-cart-sample]');
    block.querySelectorAll('[data-sample-list] [data-sample-card]').forEach(function (card) {
      card.hidden = q !== '' && (card.getAttribute('data-search') || '').indexOf(q) === -1;
    });
  });

  var config = window.alkyraSample || {};
  var PICK_KEY = '_muestra_elegida';

  // A Pack counts as 3 perfumes. Keep in sync with snippets/sample-perfume-count.liquid.
  function perfumeCount(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      if (String(item.product_id) === String(config.productId)) return sum;
      return sum + item.quantity * (item.product_type === 'Pack' ? 3 : 1);
    }, 0);
  }

  // 0 = no perfume, 1 = one perfume (we choose the sample), 2 = two (the customer chooses),
  // 3 = three or more (the customer chooses one and we add another). Keep in sync with cart-sample.liquid.
  function sampleTier(cart) {
    return Math.min(perfumeCount(cart), 3);
  }

  function packUnits(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (item.product_type === 'Pack' ? item.quantity : 0);
    }, 0);
  }

  // Each pack brings 2 samples: its curated one (the "Elegida por nosotros" line, one unit per pack)
  // and one the customer picks. Without packs: 1 pick from 2 perfumes, 1 surprise with 1 or 3+.
  function maxPicks(cart) {
    var packs = packUnits(cart);
    if (packs) return packs;
    return sampleTier(cart) >= 2 ? 1 : 0;
  }

  function surpriseQuantity(cart) {
    var packs = packUnits(cart);
    if (packs) return packs;
    var tier = sampleTier(cart);
    return tier === 1 || tier === 3 ? 1 : 0;
  }

  // Matches data-sample-tier in snippets/cart-sample.liquid.
  function sampleKey(cart) {
    return sampleTier(cart) + ':' + packUnits(cart);
  }

  function pickLines(cart) {
    var surpriseId = String(config.surpriseId);
    return (cart.items || []).filter(function (item) {
      return String(item.product_id) === String(config.productId) && String(item.variant_id) !== surpriseId;
    });
  }

  // Keeps the sample lines in line with the rule: with exactly 1 perfume the line is the
  // "Elegida por nosotros" variant and any pick the customer made waits in the PICK_KEY cart
  // attribute; with 2 that pick replaces the surprise; from 3 the pick and the surprise go together
  // (one of each per pack). Resolves with the new cart, or null.
  function reconcile(cart) {
    if (!config.productId || !config.surpriseId) return Promise.resolve(null);
    var surpriseId = String(config.surpriseId);
    var surprise = (cart.items || []).filter(function (item) { return String(item.variant_id) === surpriseId; })[0];
    var picks = pickLines(cart);
    var pending = String((cart.attributes || {})[PICK_KEY] || '');
    var tier = sampleTier(cart);
    var updates = {};
    var attributes = null;

    if (tier === 0) {
      if (surprise) updates[surpriseId] = 0;
      if (pending) attributes = {};
    } else if (tier === 1) {
      if (picks.length) {
        attributes = {};
        attributes[PICK_KEY] = String(picks[0].variant_id);
        picks.forEach(function (item) { updates[item.variant_id] = 0; });
      }
      if (picks.length || !surprise || surprise.quantity !== 1) updates[surpriseId] = 1;
    } else {
      var hasPick = picks.length > 0;
      if (pending) {
        if (!hasPick) updates[pending] = 1;
        hasPick = true;
        attributes = {};
      }
      if (tier === 3) {
        var wanted = surpriseQuantity(cart);
        if (!surprise || surprise.quantity !== wanted) updates[surpriseId] = wanted;
      } else if (surprise && hasPick) {
        updates[surpriseId] = 0;
      }
      var limit = maxPicks(cart);
      picks.forEach(function (item, index) {
        if (index >= limit) updates[item.variant_id] = 0;
        else if (item.quantity > 1) updates[item.variant_id] = 1;
      });
    }

    if (attributes && !attributes[PICK_KEY]) attributes[PICK_KEY] = '';
    if (!Object.keys(updates).length && !attributes) return Promise.resolve(null);
    var body = { updates: updates };
    if (attributes) body.attributes = attributes;
    return post('cart/update.js', body);
  }

  function rerender(cart, changed) {
    var block = document.querySelector('[data-cart-sample]');
    var tierChanged = block && sampleKey(cart) !== block.getAttribute('data-sample-tier');
    if (!changed && !tierChanged) return;
    if (isCartPage()) {
      window.location.reload();
      return;
    }
    if (changed) document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart, source: 'sample' } }));
    var drawer = document.querySelector('cart-drawer-section');
    if (drawer && typeof drawer.refresh === 'function') drawer.refresh();
  }

  function sync(cart) {
    return reconcile(cart)
      .then(function (fresh) { rerender(fresh || cart, !!fresh); })
      .catch(function (err) { console.error('[sample] sync failed:', err && err.message); });
  }

  // Any cart edit outside this file (add to cart, quantity, remove) can change the sample rule.
  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart || event.detail.source === 'sample') return;
    sync(cart);
  });

  function init() {
    if (!config.itemCount) return;
    getCart().then(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
